import React from 'react';
import DefaultLanguageSwitcher from '../../../../../../base/components/layout/right-toolbar/language-switcher';

const LanguageSwitcher = (props) => <DefaultLanguageSwitcher {...props} />;

export default LanguageSwitcher;
